<template>
  <div id="app">
    <div class="w-screen h-screen flex flex-col">
      <MainHeader />
      <div class="flex-grow main-content">
        <router-view></router-view>
      </div>
      <MainFooter />
    </div>
  </div>
</template>

<script>
import MainFooter from './components/MainFooter.vue';
import MainHeader from './components/MainHeader.vue';

export default {
  name: "App",
  components: {MainHeader, MainFooter},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* background-color: #f0f2f5; */
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.main-content {
  padding-top: 112px;
}
</style>
